/* eslint-disable import/prefer-default-export */
export class FormDataHubAdjustmentTaxInvoice {
    businessName = ''; // 필수
    ceoName = ''; // 필수
    address = {
        siDo: '', // 필수
        siGunGu: '', // 필수
        eupMyeonDong: '',
        ri: '',
        landNumber: '',
        roadName: '',
        buildingNumber: '',
        buildingName: '',
        detail: '',
    };
    businessCondition = '';
    businessType = '';
    contactTelephone = '';
    contactName = '';
    contactEmail = ''; // 공급자 담당자 이메일(invoicerContactInfo.email)
    initFormData(taxInvoiceData) {
        if (taxInvoiceData.id === null) {
            return;
        }
        const { businessName, ceoName, businessCondition, businessType, address, } = taxInvoiceData.invoicerBusinessInfo;
        const { email: contactEmail, telephone: contactTelephone, name: contactName, } = taxInvoiceData.invoicerContactInfo;
        Object.assign(this, {
            businessName,
            ceoName,
            businessCondition,
            businessType,
            address,
            contactEmail,
            contactName,
            contactTelephone,
        });
    }
    updateAddressData(address, isRoadName) {
        const { siDo, siGunGu, eupMyeonDong, landNumber, roadName, buildingNumber, buildingName, } = address;
        const addressRoad = {
            siDo,
            siGunGu,
            roadName,
            buildingNumber,
            buildingName,
        };
        // 주소 검색에서 리가 있는 경우엔 도로명에도 동을 노출 중
        const hasRi = eupMyeonDong?.includes('리');
        if (eupMyeonDong && hasRi) {
            Object.assign(addressRoad, {
                eupMyeonDong: eupMyeonDong.split(' ')[0],
            });
        }
        const addressJibun = {
            siDo,
            siGunGu,
            eupMyeonDong,
            landNumber,
        };
        const selectedAddress = isRoadName ? addressRoad : addressJibun;
        Object.assign(this, {
            address: selectedAddress,
        });
    }
}
